import { render, staticRenderFns } from "./ITextCollapse.vue?vue&type=template&id=0344114a&scoped=true&"
import script from "./ITextCollapse.vue?vue&type=script&lang=js&"
export * from "./ITextCollapse.vue?vue&type=script&lang=js&"
import style0 from "./ITextCollapse.vue?vue&type=style&index=0&id=0344114a&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0344114a",
  null
  
)

export default component.exports